// extracted by mini-css-extract-plugin
module.exports = {"root":"DashboardFilters_root__16BDa"};